<script>
import swal from "sweetalert2";
import moment from 'moment';

export default {
  data() {
    return {
      showMsg: false,
      loading: false,
      noData: false,
      domains: [],
      node: '',
      hostname: '',
      rHostname: '',
      backups: [],
      dateSort: null
    }
  },
  methods: {
    getTime(date){
      return moment(date).format('MMM Do, YYYY, hh:mm:ss A')
    },
    initDataTable (msg) {
      $(".bb-datatable").DataTable().destroy();
        $(".bb-datatable").DataTable({
          ordering: false,
          retrieve: true,
          language: {
            search: "_INPUT_",
            searchPlaceholder: "Search",
            emptyTable: "No backup exist in the system",
            size: '40'
          }
        });
    },
    async getVpsBackup () {
      try {
        if(!this.hostname) {
          swal('Error', 'Please enter hostname first.', 'error')
          return
        }
        this.loading = true

        this.showMsg = false
        this.noData = false
        this.backups = []
        this.domains = []
        this.node = ''
        // $(".bb-datatable").DataTable().destroy();
        this.noData = false
        let resp = await this.$http.post('/backup/fetch-backups-by-hostname',{
          grant_type:'token',
          hostname: this.hostname
        });
        console.log('resp', resp)
        if(resp.data.success){
          console.log('resp.data', resp.data)
          const {result} = resp.data;
          this.backups = result.matches[0].backups
          this.domains = result.matches[0].domains
          this.node = result.matches[0].node
          setTimeout(()=> {
            this.initDataTable()
          }, 300)
        } else {
          this.noData = true
          this.backups = []
          this.domains = []
          this.node = ''
          this.initDataTable("No backup exists");
        }
        this.showMsg = true
      } catch (e) {
        console.log(e)
        console.log('error while fetching vps backups', e.toString())
      } finally {
        this.rHostname = this.hostname
        this.loading = false;
        this.hostname = ''
      }
    },
  }
}
</script>

<template>
  <div class="content">
    <div class="row animated fadeIn">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title pull-left">
              Backups
            </h4>
          </div>
          <div class="card-body">
            <div class="row mb-20">
              <div class="col-md-3">
                <label for=""><b>Hostname</b></label>
                <input @keydown.enter="getVpsBackup"  v-model="hostname" placeholder="Search by hostname" type="text" class="form-control">
              </div>
              <div class="col-md-2 d-flex align-items-end">
                <button @click="getVpsBackup()" class="btn btn-primary mb-0" :disabled="loading">Search</button>
                <div class="loader small_loader ml-20" v-if="loading"></div>
              </div>
              <div class="col-md-4" v-if="showMsg">
                <b>Hostname:</b>
                <ul><li>{{rHostname}}</li></ul>
              </div>
              <div class="col-md-3" v-if="!noData && showMsg">
                <b>Node:</b>
                <ul><li>{{node}}</li></ul>
              </div>
            </div>
            <table class="table table-striped table-bordered bb-datatable">
              <thead>
              <tr>
                <th class="text-center">Date</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(row, index) in backups" :key="index">
                <td width="40%">{{getTime(row)}}</td>
              </tr>
              </tbody>
            </table>
            <div v-if="noData && showMsg">
              No backup found for this hostname.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>